import State from '../core/State';
import { SegmentData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSalesBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.salesBySegments.fetching = draft.salesBySegments.fetching + 1;
  });

export const setSalesBySegments = (segmentData: SegmentData[]) =>
  produce((draft: Draft<State>) => {
    draft.salesBySegments.data = segmentData;
  });

export const finishFetchingSalesBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.salesBySegments.fetching = draft.salesBySegments.fetching - 1;
  });

export const disposeSalesBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.salesBySegments.data = initialState.salesBySegments.data;
    draft.salesBySegments.fetching = initialState.salesBySegments.fetching;
  });
